import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {
  ReactPlugin,
  withAITracking,
} from '@microsoft/applicationinsights-react-js';
import { globalHistory } from '@reach/router';

const connectionString = process.env.GATSBY_AZURE_MONITOR_CONNECTION_STRING;
const instanceName =
  process.env.GATSBY_AZURE_MONITOR_ROLE_INSTANCE_NAME || 'main';
const samplingPercentage = parseInt(
  process.env.GATSBY_AZURE_MONITOR_SAMPLING_PERCENTAGE || '100',
  10,
);

const supportedHosts = {
  '*.spaseekers.com': /.*\.spaseekers\.com$/gi,
  'spaseekers.com': /spaseekers.com$/gi,
  '*.netlify.app': /.*\.netlify\.app$/gi,
  'localhost:*': /localhost:.*/gi,
  '*.github.dev': /.*\.github\.dev$/gi,
};

const reactPlugin = new ReactPlugin();
const ai = new ApplicationInsights({
  config: {
    connectionString: connectionString,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: globalHistory },
    },
    samplingPercentage: samplingPercentage,
    enableCorsCorrelation: true,
    distributedTracingMode: 2,
    autoExceptionInstrumented: true,
    correlationHeaderDomains: Object.keys(supportedHosts),
  },
});

if (connectionString) {
  ai.loadAppInsights();
  ai.appInsights.addTelemetryInitializer(ev => {
    ev.tags['ai.cloud.role'] = 'Website';
    ev.tags['ai.cloud.roleInstance'] = instanceName;
  });

  const supportedHostsExpr = Object.values(supportedHosts);

  ai.appInsights.addTelemetryInitializer(ev => {
    if (
      ev.baseType === 'RemoteDependencyData' &&
      ev.baseData &&
      ev.baseData.target
    ) {
      const url = new URL(ev.baseData.target);
      if (!supportedHostsExpr.some(exp => exp.test(url.hostname))) {
        // Do not send telemetry for 3rd party domains
        return false;
      }
      if (url.pathname.test(/page-data/gi)) {
        // Do not send telemetry for Gatsby page-data files
        return false;
      }
    }
  });
} else {
  console.log('Application insights not available.');
}

const waitForFlushCore = function (callback) {
  if (ai.appInsights.core && ai.appInsights.core.flush) {
    var willExecuteCallback = ai.appInsights.core.flush(true, callback);
    if (willExecuteCallback) {
      return;
    }
  }

  callback();
};

export default Component => withAITracking(reactPlugin, Component);
export const appInsights = ai.appInsights;
export const waitForFlush = waitForFlushCore;
